import MuiPaper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

export default withStyles({
  root: {
    borderRadius: 10,
    boxShadow: '0 0 20px #E4E4E4',
  },
})(MuiPaper);
